import { Injectable } from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ChangelogService {

  constructor(
    public afs: AngularFirestore,
  ) { }

  addNewChangelog(data) {
    return this.afs.doc(`changelog/${data.appVersion}`).set(data);
  }
  getChangelogs() {
    return this.afs.collection(`changelog/`).valueChanges();
  }
  getCurrentVersionChangelog(appVersion) {
    return this.afs.collection('changelog', ref => ref.where('appVersion', '==', appVersion)).valueChanges();
  }
}
